import { render, staticRenderFns } from "./make-payment.vue?vue&type=template&id=ef6ae05e&scoped=true&"
import script from "./make-payment.vue?vue&type=script&lang=js&"
export * from "./make-payment.vue?vue&type=script&lang=js&"
import style0 from "./make-payment.vue?vue&type=style&index=0&id=ef6ae05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6ae05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6ae05e')) {
      api.createRecord('ef6ae05e', component.options)
    } else {
      api.reload('ef6ae05e', component.options)
    }
    module.hot.accept("./make-payment.vue?vue&type=template&id=ef6ae05e&scoped=true&", function () {
      api.rerender('ef6ae05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/make-payment.vue"
export default component.exports